import { Box, inputBaseClasses, styled } from '@mui/material';

import { SquareIconButton } from '../../../../../../Button/SquareIconButton/SquareIconButton';
import { TimeField } from '../../../../../../form/TimeField/TimeField';

export const StyledTimeField = styled(TimeField)`
    input::-webkit-calendar-picker-indicator {
        display: none;
        color: ${({ theme }) => theme.palette.blue.dark};
        width: 20px;
        height: 20px;
        filter: none;
    }

    &.textInGray {
        & > .${inputBaseClasses.root} {
            input,
            textarea {
                color: #b6d2e5;
            }
        }
    }

    &.textInBlack {
        & > .${inputBaseClasses.root} {
            input,
            textarea {
                color: ${({ theme }) => theme.palette.blue.dark};
            }
        }
    }

    & > .${inputBaseClasses.root} {
        background-color: white;
        border: solid 1px #b6d2e5;

        input,
        textarea {
            color: ${({ theme }) => theme.palette.blue.dark};
        }

        &.MuiFilledInput-root {
            &.Mui-focused,
            &:hover {
                background-color: white;
            }

            &.Mui-error {
                border-color: red;
            }
        }
    }
`;
export const StyledSquareIconButton = styled(SquareIconButton)`
    background-color: #006ebb;
    height: 20px;
    width: 20px;
    border: none;

    &.Mui-disabled {
        background-color: rgba(255, 255, 255, 0.2);
    }

    &:hover {
        background-color: #006ebb;
    }
`;
export const StyledButtonsBox = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
